import {createContext} from "preact";

export const ProductContext = createContext({type: '', name: '', obsDimensions: {width: '', height: ''}});